export default __webpack_public_path__ + "media/images/elephant_ui_plane-6e7db59315e9c2b0a03c1c5996e9ba5d.svg";